<template lang="pug">
  .input_email
    input-text(
      v-model="email"
      :label="label"
      :required="required"
      :disabled="disabled"
      :readonly="readonly"
      :rules="getRules"
      :placeholder="placeholder"
      :icon="icon"
      :maxlength="maxlength"
      @update:error="onError($event)"
    )
</template>

<script>
import InputText from 'Support/components/inputs/InputText.vue';

export default {
  name: 'InputEmail',
  components: {
    InputText,
  },
  props: {
    value: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      default: 'E-mail',
    },
    required: {
      type: Boolean,
    },
    placeholder: {
      type: String,
      default: '',
    },
    readonly: {
      type: Boolean,
    },
    disabled: {
      type: Boolean,
    },
    rules: {
      type: Array,
      default() {
        return [];
      },
    },
    maxlength: {
      type: [String, Number],
      default: '',
    },
  },
  data() {
    return {
      isValid: true,
      rulesNative: {
        required: value => !!value || this.$t('support.components.inputs.required'),
        validMail: (value) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          this.isValid = pattern.test(this.value);
          return pattern.test(value) || this.$t('support.components.inputs.email.invalid');
        },
      },
    };
  },
  computed: {
    email: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    icon() {
      if (!this.email) return '';
      return !this.isValid ? 'warning' : 'check';
    },
    getRules() {
      const rules = [];
      if (this.required) rules.push(this.rulesNative.required);
      if (this.value) rules.push(this.rulesNative.validMail);
      return rules.concat(this.rules);
    },
  },
  methods: {
    onError(value) {
      this.isValid = value;
    },
  },
};
</script>
